module.exports = __webpack_public_path__ + "static/media/liked.18b690b1.png";